import { z } from 'zod';
export const adminOtpRequestSchema = z.object({ phone: z.string().trim().min(1).max(20) });
export const adminOtpVerifySchema = z.object({
    phone: z.string().trim().min(1).max(20),
    code: z.string().regex(/^\d{6}$/),
});
export const adminTotpSchema = z.object({
    token: z.string().min(10).max(2000),
    code: z.string().regex(/^\d{6}$/),
});
export const adminPlanSchema = z.object({
    planCode: z.string().trim().min(1).max(40),
    /** Marks the agency as one of the first 25 (allows the founding plans). */
    founding: z.boolean().optional(),
    reason: z.string().trim().min(5).max(300),
});
export const trialExtensionSchema = z.object({
    days: z.number().int().min(1).max(90),
    reason: z.string().trim().min(5).max(300),
});
export const readOnlyToggleSchema = z.object({
    readOnly: z.boolean(),
    reason: z.string().trim().min(5).max(300),
});
export const impersonateSchema = z.object({ reason: z.string().trim().min(10).max(300) });
/** Every step on a data request says why, and the reason is kept in the audit trail. */
export const dataRequestDecisionSchema = z.object({ note: z.string().trim().min(5).max(500) });
/** A client asks, from the public page, to export or delete their data (DPDP). */
export const privacyOtpSchema = z.object({ phone: z.string().trim().min(1).max(20) });
export const privacyRequestSchema = z.object({
    phone: z.string().trim().min(1).max(20),
    code: z.string().regex(/^\d{6}$/),
    kind: z.enum(['export', 'delete']),
});
export const agencyDeletionSchema = z.object({ confirmName: z.string().trim().min(1).max(120) });
/** Why a support action is taken: always asked for, always kept in the audit trail. */
export const supportReasonSchema = z.object({ reason: z.string().trim().min(5).max(300) });
export const clearLockoutSchema = z.object({
    phone: z.string().trim().min(10).max(16),
    reason: z.string().trim().min(5).max(300),
});
/** The marketing site's "ask for early access" form. */
export const earlyAccessSchema = z.object({
    name: z.string().trim().min(2).max(80),
    phone: z.string().trim().min(10).max(16),
    city: z.string().trim().min(2).max(60),
    agencySize: z.enum(['solo', '2-5', '6-15', '16+']),
});
export const EARLY_ACCESS_STATUSES = ['new', 'called', 'onboarded'];
export const earlyAccessStatusSchema = z.object({
    status: z.enum(EARLY_ACCESS_STATUSES),
    note: z.string().trim().max(300).optional(),
    reason: z.string().trim().min(5).max(300),
});
/** Ending a memo signing link: the agency is named so the database still decides what may change. */
export const memoLinkRevokeSchema = z.object({
    agencyId: z.string().uuid(),
    reason: z.string().trim().min(5).max(300),
});
/** A query string flag: "true" or "false" (a real boolean is also taken). */
const queryFlag = z
    .union([z.boolean(), z.enum(['true', 'false']).transform((v) => v === 'true')])
    .default(false);
/** The Audit tab's filters and page. Read from the query string, so numbers and flags arrive as text. */
export const auditQuerySchema = z.object({
    agencyId: z.string().uuid().optional(),
    /** One action prefix, or several joined by commas: "plan.,trial." */
    action: z
        .string()
        .trim()
        .max(200)
        .regex(/^[a-z_.]+(,[a-z_.]+)*$/)
        .optional(),
    from: z.string().date().optional(),
    to: z.string().date().optional(),
    includeSignIns: queryFlag,
    limit: z.coerce.number().int().min(1).max(100).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
//# sourceMappingURL=admin.js.map